module.exports = __webpack_public_path__ + "static/media/dcsg_thumb.e450e8d5.png";